import { disablePageScroll, enablePageScroll } from 'scroll-lock';
export default {
    ie11_top: 0,
    ie11_width: 0,
    ie11_disable_scroll: function() {
        window.scrollTo(this.ie11_top, this.ie11_width);
        console.log("IE11 Scrolling");
    },
    init() {
        let that = this;
        let buttons = document.getElementsByClassName('info-btn');
        let modals = document.getElementsByClassName("info-modal");
        if(buttons.length > 0) {
            //close dropdowns if clicked outside.
            $(document).mouseup(function(e) {
                if(modals) {
                    var container = $(".info-holder");
                    let is_not_container = !container.is(e.target);
                    let has_no_container = container.has(e.target).length === 0;

                    // if the target of the click isn't the container nor a descendant of the container
                    if (is_not_container && has_no_container) {
                        for(let j = 0; j < modals.length; j++) {
                            let modal = modals[j];
                            if(modal.classList.contains('info-modal--active')) {
                                modal.classList.remove('info-modal--active');
                                that.enable_scrolling();
                            }
                        }
                    }
                }
            });

            for(let i = 0; i < buttons.length; i++) {
                let button = buttons[i];
                //if we are mobile and we click on the modal
                button.parentElement.querySelector('.info-modal').addEventListener('click', function(e) {
                    if(e.target === this && window.innerWidth < 1000) {
                        console.log("Closing info window!");
                        // that.close_popovers(this);
                        this.classList.remove('info-modal--active')
                        that.enable_scrolling();
                    }
                })

                let close_button = button.nextElementSibling.querySelector('.modal-close');
                close_button.addEventListener('click', function(e) {
                    this.parentElement.parentElement.classList.remove('info-modal--active');
                    that.enable_scrolling();
                    // that.close_popovers(this.parentElement.parentElement.nextElementSibling);
                })
                button.addEventListener('click', function(e) {
                    let parent = $(this).closest('.header-column');
                    // this.nextElementSibling.classList.toggle('info-modal--active');
                    that.close_popovers(this.nextElementSibling);
                    if(this.nextElementSibling.classList.contains('info-modal--active')) {
                        if(window.innerWidth < 1000) {
                            that.enable_scrolling();
                        }
                        this.nextElementSibling.classList.remove('info-modal--active');

                        if(parent) {
                            $(parent).removeAttr('style')
                        }
                    } else {
                        if(window.innerWidth < 1000) {
                            that.disable_scrolling()
                        }
                        this.nextElementSibling.classList.add('info-modal--active');

                        if(parent) {
                            parent.css({ zIndex: 5 });
                        }

                        //TODO: Find way to fix this.
                        // if(window.innerWidth < 1000) {
                        //     $(this.nextElementSibling).clone().appendTo("body");
                        // }
                    }
                    // if(window.innerWidth < 1000 && this.nextElementSibling.classList.contains('info-modal--active')) {
                        
                    // } 
                })
            }
        }
    },
    close_popovers(el) {
        let popovers = document.getElementsByClassName('info-modal');
        if(popovers.length > 0) {
            for(let i = 0; i < popovers.length; i++) {
                let popover = popovers[i];
                let parent = $(popover).closest('.header-column');
                if(el != popover) {
                    popover.classList.remove('info-modal--active');

                    if(parent) {
                        $(parent).removeAttr('style')
                    }
                }
            }
        }
    },
    disable_scrolling() {
        // document.body.classList.add('locked')
        // document.documentElement.classList.add('locked')
        // $('body').bind('touchmove', function(e){e.preventDefault()})
        // disablePageScroll();

        this.ie11_top = document.documentElement.scrollTop;
        this.ie11_width = document.documentElement.scrollWidth;

        if(navigator.userAgent.indexOf('MSIE')!==-1
        || navigator.appVersion.indexOf('Trident/') > -1){
        /* Microsoft Internet Explorer detected in. */
            window.addEventListener('scroll', this.ie11_disable_scroll);
            console.log("Disabling scroll on IE");
        } else {
            console.log("Not IE11");
            disablePageScroll();
        }
    },
    enable_scrolling() {
        // document.body.classList.remove('locked')
        // document.documentElement.classList.remove('locked')
        // $('body').unbind('touchmove')
        // enablePageScroll();
        if(navigator.userAgent.indexOf('MSIE')!==-1
        || navigator.appVersion.indexOf('Trident/') > -1){
        /* Microsoft Internet Explorer detected in. */
            window.removeEventListener('scroll', this.ie11_disable_scroll)
            console.log("Enabling scroll on IE");
        } else {
            console.log("Not IE11");
            enablePageScroll();
        }
    }
}